import React from 'react';
import BaseModal from '../../../../components/basemodal';
import { IOcorrencia } from '../../../../@interfaces/rondas';
import MensagemListaVazia from '../../../../components/mensagemlistavazia';

interface IOcorrenciasModalProps {
  closeModal: () => void;
  ocorrencias: IOcorrencia[];
  titulo: string
}

function situacaoOcorrenciaColor(situacao: string) {
  const map: Record<string, string> = {
    'PENDENTE': 'bg-yellow-100 text-yellow-700',
    'JUSTIFICADA': 'bg-blue-100 text-blue-700',
    'FECHADA': 'bg-green-100 text-green-700',
  };
  return map[situacao.toUpperCase()] ?? 'bg-gray-100 text-gray-700';
}

const OcorrenciasModal: React.FC<IOcorrenciasModalProps> = ({ closeModal, ocorrencias, titulo }) => {
  return (
    <BaseModal closeModal={closeModal} width={`480px`} >
      <div className="flex flex-col gap-3 max-h-[70vh] overflow-y-auto p-2 pb-10">
        <span className='text-center'>{titulo}</span>
        {ocorrencias.length > 0 && <span className='px-3'>{ocorrencias.length === 1 ? "1 ocorrência": `${ocorrencias.length} ocorrências`}</span>}
        {ocorrencias.map(ocorrencia => (
          <div
            key={ocorrencia.ocorrencia}
            className="flex flex-col gap-1 border border-solid border-gray-200 rounded-lg p-3"
          >
            <div className="flex items-center justify-between">
              <span className="font-medium text-black/80 text-sm">{ocorrencia.descricaoOcorrencia}</span>
              <span className={`text-xs px-2 py-0.5 rounded-full ${situacaoOcorrenciaColor(ocorrencia.situacaoOcorrencia)}`}>
                {ocorrencia.situacaoOcorrencia}
              </span>
            </div>

            <span className="text-xs text-black/50"><span className="font-medium">Motivo: </span>{ocorrencia.motivoOcorrencia}</span>
            {ocorrencia.descricaoUsuario && (
              <span className="text-sm italic text-black/40 mt-1"><span className="font-medium not-italic">Descrição funcionário: </span>"{ocorrencia.descricaoUsuario}"</span>
            )}
          </div>
        ))}

        {ocorrencias.length === 0 && <MensagemListaVazia texto='Nenhuma ocorrência foi registrada nesse ponto'/>}




      </div>
    </BaseModal>
  )
}

export default OcorrenciasModal;